import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["yearlyLabel", "monthlyLabel", "dot", "yearly", "monthly"]
  static values = { period: { type: String, default: "yearly" } }

  toggle() {
    this.periodValue = this.periodValue === "yearly" ? "monthly" : "yearly"
  }

  setYearly() { this.periodValue = "yearly" }
  setMonthly() { this.periodValue = "monthly" }

  periodValueChanged() {
    const yearly = this.periodValue === "yearly"
    this.yearlyLabelTarget.classList.toggle("is-active", yearly)
    this.monthlyLabelTarget.classList.toggle("is-active", !yearly)
    this.dotTarget.classList.toggle("is-monthly", !yearly)
    this.yearlyTargets.forEach((el) => el.hidden = !yearly)
    this.monthlyTargets.forEach((el) => el.hidden = yearly)
  }
}
